"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BannerContainer_1 = require("../../Components/BannerContainer");
var NameView_1 = require("../../Components/NameView");
var PriceView_1 = require("../../Components/PriceView");
var StarAndSold_1 = require("../../Components/StarAndSold");
var TwentyFour_1 = require("../../Components/TwentyFour");
var styled_1 = require("./styled");
var utils_1 = require("../utils");
var DoubleCard = function (props) {
    var imgWidth = props.imgWidth, imgHeight = props.imgHeight;
    var _a = utils_1.getInitProduct(props.product), img = _a.img, name = _a.name, price = _a.price, originPrice = _a.originPrice, url = _a.url, ltImg = _a.ltImg, rtImg = _a.rtImg, countdownToEnd = _a.countdownToEnd, sold = _a.sold, star = _a.star, titleImg = _a.titleImg, twentyTour = _a.twentyTour;
    return (React.createElement(styled_1.DoubleCardWrap, { imgWidth: imgWidth, href: url },
        React.createElement(BannerContainer_1.BannerContainer, { imgWidth: imgWidth, imgHeight: imgHeight, banner: img, ltImg: ltImg, rtImg: rtImg, countdownToEnd: countdownToEnd }),
        React.createElement(styled_1.Desc, null,
            React.createElement(NameView_1.NameView, { name: name, activeImg: titleImg }),
            React.createElement(PriceView_1.PriceView, { price: price, originPrice: originPrice, type: PriceView_1.PriceUIType.Large }),
            React.createElement(StarAndSold_1.StarAndSold, { star: star, sold: sold }),
            React.createElement(TwentyFour_1.TwentyFour, { text: twentyTour }))));
};
exports.default = DoubleCard;
